import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

const Actions = ({ classes, data }) => (
  <div className={classes.root}>
    {data.map(
      item =>
        item.text && (
          <Fragment>
            <Chip className={`${classes.pill} ${classes[item.color]}`} size='small' label={item.text} />
            <br />
          </Fragment>
        ),
    )}
  </div>
);

Actions.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      color: PropTypes.oneOf(['info', 'warning', 'success']).isRequired,
    }),
  ),
};

Actions.defaultProps = {
  data: [
    { text: 'ownership', color: 'info' },
    { text: 'lease', color: 'warning' },
  ],
};

export default withStyles(theme => ({
  root: {
    textAlign: 'right',
  },
  pill: {
    margin: '3px 0',
  },
  info: {
    color: theme.palette.primary.infoBlue,
    border: `1px solid ${theme.palette.primary.infoBlue}`,
    background: theme.palette.primary.infoBlueLight,
  },
  warning: {
    color: theme.palette.primary.warningMango,
    border: `1px solid ${theme.palette.primary.warningMango}`,
    background: theme.palette.primary.warningMangoLight,
  },
  success: {
    color: theme.palette.primary.successGreen,
    border: `1px solid ${theme.palette.primary.successGreen}`,
    background: theme.palette.primary.successGreenLight,
  },
}))(Actions);
